import React from "react";
import Popup from "reactjs-popup";
import "./popup.css";

const DATABNF_ASKQUERYFORM_URL =
  process.env.PUBLIC_URL + "/../thickbox/askquery/";

const AskQueryComponent = () => {
  const [form, setForm] = React.useState({});

  React.useEffect(() => {
    fetch(DATABNF_ASKQUERYFORM_URL)
      .then((response) => response.text())
      .then((text) => setForm({ __html: text }));
  }, []);

  return (
    <Popup
      trigger={<button className="button popup"> Demander une requête </button>}
      modal
      nested
    >
      {(close) => (
        <div className="modal">
          <button className="close" onClick={close}>
            &times;
          </button>
          <div className="header">Demander une requête</div>
          <div className="content" dangerouslySetInnerHTML={form} />
        </div>
      )}
    </Popup>
  );
};

export default function Header() {
  return (
    <header>
      <div className="content-header">
        <div className="logos">
          <a
            href="http://www.bnf.fr"
            title="Lien vers le site institutionnel www.bnf.fr"
          >
            <img
              src="https://data.bnf.fr/fr/v2/static/databnf_logo.png"
              alt="Bnf"
            />
          </a>
          <a
            id="databnf-logo"
            href="https://data.bnf.fr/fr/"
            title="Lien vers la page d&#39;accueil du site data.bnf.fr"
          >
            Data
          </a>
        </div>
        <div className="liens-transverses">
          <AskQueryComponent />
          <a href="http://api.bnf.fr/dumps-de-databnffr" rel="nofollow">
            Télécharger les données
          </a>
          <a href="https://data.bnf.fr/images/modele_donnees_2018_02.pdf" rel="nofollow">
            Le modèle de données
          </a>
          <a href="https://data.bnf.fr/sparnatural" rel="nofollow">
            Sparnatural
          </a>
          <a href="https://data.bnf.fr/fr/sparql_sparna_doc" rel="nofollow">
            Documentation sur sparql et sparnatural
          </a>
          <a href="https://data.bnf.fr/fr/contact" rel="nofollow">
            Contact
          </a>
        </div>
      </div>
    </header>
  );
}
